module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/420ac8dcfdacd63b159f8cf2033a4f31.png";